import React from "react";
import { Callout } from "@sscs/ui";
import styles from "./unsavedWarning.module.scss";

type UnsavedWarningProps = {
  isDisplayed: boolean;
};

const UnsavedWarning = ({
  isDisplayed,
}: UnsavedWarningProps): React.JSX.Element => {
  if (!isDisplayed) return <></>;

  return (
    <Callout
      type="error"
      title="This change has not been saved"
      className={styles["unsaved-warning"]}
      variant="inline"
    />
  );
};
export default UnsavedWarning;
